import { useCallback, useEffect, useState } from 'react';
import { getTENANTLayerId } from '../../../../utils';

interface UseDashboardDataParams {
  dashboardName: string;
  fetchFromOrion: boolean;
}

export interface DashboardData {
  layerType: string;
  [key: string]: unknown;
}

type FetchError = any;

const useDashboardData = ({ dashboardName, fetchFromOrion }: UseDashboardDataParams) => {
  const [isTenantDashboard, setIsTenantDashboard] = useState<boolean>(false);
  const [dashboardData, setDashboardData] = useState<DashboardData | null>(null);
  const [dashboardFetchError, setDashboardFetchError] = useState<FetchError | null>(null);

  const fetchDashboardData = useCallback(async () => {
    if (!fetchFromOrion) {
      console.log('Fetching from Orion is disabled.');
      return;
    }

    const getRequest = new Request(`/session/api/ext/objstore/v1beta/objects/platformui:dashboard/${dashboardName}`, {
      headers: {
        Accept: 'application/json; charset=UTF-8',
        'layer-type': 'TENANT',
        'layer-id': getTENANTLayerId(),
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });

    try {
      const response = await fetch(getRequest);
      const data: DashboardData = await response.json();
      if (data.layerType === 'TENANT') {
        setIsTenantDashboard(true);
      }
      setDashboardData(data);
    } catch (err) {
      console.error('Failed to fetch dashboard:', err);
      setDashboardFetchError(err as FetchError);
    }
  }, [dashboardName, fetchFromOrion]);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  return { dashboardData, isTenantDashboard, dashboardFetchError };
};

export default useDashboardData;
